// Field type constants
export const FIELD_TYPES = {
  TEXT: 'text',
  NUMERIC: 'numeric', 
  BOOLEAN: 'boolean',
  DATE: 'date',
  EVENT: 'event',
  STATUS: 'status'
};

// Operator constants
export const OPERATORS = {
  EQUALITY: ['Is', 'Is Not'],
  COMPARISON: ['>', '<', '>=', '<='],
  TEXT: ['Like', 'Not Like'],
  NULL: ['Is Empty', 'Is Not Empty']
};

// Field configuration mapping
export const FIELD_CONFIG = {
  // Text fields - only equality and null operators for names, text operators for email
  "First Name": { 
    type: FIELD_TYPES.TEXT, 
    operators: [...OPERATORS.EQUALITY, ...OPERATORS.NULL] 
  },
  "Last Name": { 
    type: FIELD_TYPES.TEXT, 
    operators: [...OPERATORS.EQUALITY, ...OPERATORS.NULL] 
  },
  "Email": { 
    type: FIELD_TYPES.TEXT, 
    operators: [...OPERATORS.EQUALITY, ...OPERATORS.TEXT] 
  },
  // New: Sent From (sender email) - behaves like Email
  "sentFromEmail": { 
    type: FIELD_TYPES.TEXT, 
    operators: [...OPERATORS.EQUALITY, ...OPERATORS.TEXT] 
  },
  "Campaign Name": { 
    type: FIELD_TYPES.TEXT, 
    operators: [...OPERATORS.EQUALITY, ...OPERATORS.TEXT] 
  },
  
  // Numeric fields - all operators except text
  "totalSent": { 
    type: FIELD_TYPES.NUMERIC, 
    operators: [...OPERATORS.EQUALITY, ...OPERATORS.COMPARISON] 
  },
  "totalOpens": { 
    type: FIELD_TYPES.NUMERIC, 
    operators: [...OPERATORS.EQUALITY, ...OPERATORS.COMPARISON] 
  },
  "totalClicks": { 
    type: FIELD_TYPES.NUMERIC, 
    operators: [...OPERATORS.EQUALITY, ...OPERATORS.COMPARISON] 
  },
  "totalCampaigns": { 
    type: FIELD_TYPES.NUMERIC, 
    operators: [...OPERATORS.EQUALITY, ...OPERATORS.COMPARISON] 
  },
  
  // Status fields - only equality and null operators
  "emailStatus": { 
    type: FIELD_TYPES.TEXT, 
    operators: [...OPERATORS.EQUALITY, ...OPERATORS.NULL] 
  },
  "User Status": { 
    type: FIELD_TYPES.STATUS, 
    operators: [...OPERATORS.EQUALITY] 
  },
  
  // Date fields - equality, comparison, and null operators
  "Campaign Start Date": { 
    type: FIELD_TYPES.DATE, 
    operators: [...OPERATORS.EQUALITY, ...OPERATORS.COMPARISON, ...OPERATORS.NULL] 
  },
  "Campaign End Date": { 
    type: FIELD_TYPES.DATE, 
    operators: [...OPERATORS.EQUALITY, ...OPERATORS.COMPARISON, ...OPERATORS.NULL] 
  },
  "Created At": { 
    type: FIELD_TYPES.DATE, 
    operators: [...OPERATORS.EQUALITY, ...OPERATORS.COMPARISON, ...OPERATORS.NULL] 
  },
  "Activity Date": { 
    type: FIELD_TYPES.DATE, 
    operators: [...OPERATORS.EQUALITY, ...OPERATORS.COMPARISON] 
  },
  
  // Event fields - only equality and null operators
  "Campaign Event": { 
    type: FIELD_TYPES.EVENT, 
    operators: [...OPERATORS.EQUALITY] 
  },
  
  // New user fields
  "personId": { 
    type: FIELD_TYPES.NUMERIC, 
    operators: [...OPERATORS.EQUALITY, ...OPERATORS.COMPARISON] 
  },
  "messageBucket": { 
    type: FIELD_TYPES.TEXT, 
    operators: [...OPERATORS.EQUALITY, ...OPERATORS.TEXT, ...OPERATORS.NULL] 
  },
  "specialMessageDaniel": { 
    type: FIELD_TYPES.TEXT, 
    operators: [...OPERATORS.EQUALITY, ...OPERATORS.TEXT, ...OPERATORS.NULL] 
  },
  "tierNumber": { 
    type: FIELD_TYPES.NUMERIC, 
    operators: [...OPERATORS.EQUALITY, ...OPERATORS.COMPARISON] 
  },
  "tierLevel": { 
    type: FIELD_TYPES.TEXT, 
    operators: [...OPERATORS.EQUALITY, ...OPERATORS.NULL] 
  },
  "tierType": { 
    type: FIELD_TYPES.TEXT, 
    operators: [...OPERATORS.EQUALITY, ...OPERATORS.TEXT,...OPERATORS.NULL] 
  },
  "relationship": { 
    type: FIELD_TYPES.TEXT, 
    operators: [...OPERATORS.EQUALITY, ...OPERATORS.TEXT, ...OPERATORS.NULL] 
  },
  "stepNumber": { 
    type: FIELD_TYPES.NUMERIC, 
    operators: [...OPERATORS.EQUALITY, ...OPERATORS.COMPARISON] 
  }
};

// Campaign users field configuration (limited options)
export const CAMPAIGN_USERS_FIELD_CONFIG = {
  "First Name": { 
    type: FIELD_TYPES.TEXT, 
    operators: [...OPERATORS.EQUALITY, ...OPERATORS.NULL] 
  },
  "Last Name": { 
    type: FIELD_TYPES.TEXT, 
    operators: [...OPERATORS.EQUALITY, ...OPERATORS.NULL] 
  },
  "Email": { 
    type: FIELD_TYPES.TEXT, 
    operators: [...OPERATORS.EQUALITY, ...OPERATORS.TEXT] 
  },
  // New: Sent From (sender email) for campaign users
  "sentFromEmail": { 
    type: FIELD_TYPES.TEXT, 
    operators: [...OPERATORS.EQUALITY, ...OPERATORS.TEXT] 
  },
  "emailStatus": { 
    type: FIELD_TYPES.TEXT, 
    operators: [...OPERATORS.EQUALITY, ...OPERATORS.NULL] 
  },
  "Campaign Event": { 
    type: FIELD_TYPES.EVENT, 
    operators: [...OPERATORS.EQUALITY] 
  },
   // New user fields
   "personId": { 
    type: FIELD_TYPES.NUMERIC, 
    operators: [...OPERATORS.EQUALITY, ...OPERATORS.COMPARISON] 
  },
  "messageBucket": { 
    type: FIELD_TYPES.TEXT, 
    operators: [...OPERATORS.EQUALITY, ...OPERATORS.TEXT, ...OPERATORS.NULL] 
  },
  "specialMessageDaniel": { 
    type: FIELD_TYPES.TEXT, 
    operators: [...OPERATORS.EQUALITY, ...OPERATORS.TEXT, ...OPERATORS.NULL] 
  },
  "tierNumber": { 
    type: FIELD_TYPES.NUMERIC, 
    operators: [...OPERATORS.EQUALITY, ...OPERATORS.COMPARISON] 
  },
  "tierLevel": { 
    type: FIELD_TYPES.TEXT, 
    operators: [...OPERATORS.EQUALITY, ...OPERATORS.NULL] 
  },
  "tierType": { 
    type: FIELD_TYPES.TEXT, 
    operators: [...OPERATORS.EQUALITY, ...OPERATORS.TEXT,...OPERATORS.NULL] 
  },
  "relationship": { 
    type: FIELD_TYPES.TEXT, 
    operators: [...OPERATORS.EQUALITY, ...OPERATORS.TEXT, ...OPERATORS.NULL] 
  },
  "stepNumber": { 
    type: FIELD_TYPES.NUMERIC, 
    operators: [...OPERATORS.EQUALITY, ...OPERATORS.COMPARISON] 
  },
  "Activity Date": { 
    type: FIELD_TYPES.DATE, 
    operators: [...OPERATORS.EQUALITY, ...OPERATORS.COMPARISON] 
  }
};
